export const APP_SESSION_KEYS = {
  SIMULATION_MODE: 'simulationMode',
  STATE: 'state',
  PSMS_REPORT_CARD_CLICKED: 'isPSMSReportCardClicked',
  CONTRACT_ID_NAVIGATION: 'contractIdNavigation',
  HI_VOLUME_CONTRACT_FLOW: 'hiVolumeContractFlow',
} as const;

export const APP_EVENTS = {
  EXIT_PROVIDER_VIEW: 'ExitProviderView',
  SELECTED_CORPORATE_TIN_UPDATE: 'SelectedCorporateTinUpdate',
  REACT_NAVIGATION: 'reactNavigation',
  OPEN_RESPONSIVE_HAM_MENU: 'uhci-open-responsive-ham-menu',
} as const;
